var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#1DA1F2",
    width: 35,
    height: 35,
    rx: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.122 11.482a7.846 7.846 0 0 1-2.268.622A3.96 3.96 0 0 0 26.59 9.92a7.907 7.907 0 0 1-2.508.958 3.949 3.949 0 0 0-6.729 3.601 11.209 11.209 0 0 1-8.138-4.125 3.946 3.946 0 0 0 1.221 5.272 3.933 3.933 0 0 1-1.787-.494v.05a3.95 3.95 0 0 0 3.167 3.872 3.955 3.955 0 0 1-1.785.067 3.952 3.952 0 0 0 3.69 2.742 7.923 7.923 0 0 1-4.904 1.689 8.032 8.032 0 0 1-.942-.052 11.176 11.176 0 0 0 6.053 1.773c7.263 0 11.235-6.016 11.235-11.235 0-.17-.004-.341-.012-.51a8.026 8.026 0 0 0 1.97-2.044",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterAlt);
export default __webpack_public_path__ + "static/media/twitter-alt.fa744d93a0d4575db04ff3000ef6f8a6.svg";
export { ForwardRef as ReactComponent };